import RepositoryFactory from "../../admin/apis/index";
const errormanagment = RepositoryFactory.Errormanagment;
export default {
  Get({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("createerrormanagment called");
        const { data } = await errormanagment.Get(payload);
        console.log(data, "datadatadata");
        commit("GET_RESULT", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  Create({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await errormanagment.Create(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  Update({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await errormanagment.Update(payload);
        // commit("GET_RM_CONTACT", data.data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },




};
